import { Component, Inject, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

interface SnackbarInput {
  message: string;
  linkText?: string;
}

@Component({
  selector: 'snack-bar-success',
  templateUrl: './success.component.html',
  styleUrl: './success.component.css',
})
export class SuccessSnackBarComponent {
  snackBarRef = inject(MatSnackBarRef);

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarInput) {}

  closeSnackbar() {
    this.snackBarRef.dismiss();
  }

  refreshPage() {
    this.closeSnackbar();
    location.reload();
  }
}
